import { render, staticRenderFns } from "./SendSummaryForm.vue?vue&type=template&id=2d9dc67b&lang=pug"
import script from "./SendSummaryForm.vue?vue&type=script&lang=js"
export * from "./SendSummaryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Editor: require('/home/docker/code/frontend/components/Editor.vue').default})
